export default {
  title: 'Individuelle Druckerzeugnisse',
  fields: {
    name: 'Name',
    format: 'Produkttyp',
  },
  buttons: {
    upload_product: 'Upload-Prozess starten',
    preview: 'Vorschau',
    edit: 'Bearbeiten',
  },
};
